<template>
    <footer class="app-footer">
        <div class="float-left">
            © {{new Date().getFullYear()}} Alarm.ru
            <a href="http://www.facebook.com/alarmcenterru" target="_blank" type="button" class="btn btn-facebook icon btn-sm"></a>
            <a href="http://vk.com/alarmru" type="button" target="_blank" class="btn btn-vk icon btn-sm"></a>
            <a href="https://www.youtube.com/c/AlarmcenterRu?sub_confirmation=1" type="button" target="_blank" class="btn btn-youtube icon btn-sm"></a>
            <a href="https://www.instagram.com/alarm_ru/" type="button" target="_blank" class="btn btn-instagram icon btn-sm"></a>
            <a href="https://t.me/alarmru" type="button" target="_blank" class="btn btn-telegram icon btn-sm"></a>
            <br>
            <a href="https://form.asana.com?k=7V8BvVXyrVWqsLOv1fjmhA&d=954381603374797" target="_blank">Замечания и предложения</a>
        </div>
        <div class="float-right">
            <span class="">Отдел продаж&nbsp;&nbsp;&nbsp;<i class="fa fa-phone"></i>&nbsp;+7&nbsp;903 724-81-17</span><br>
            <span class="">Техподдержка&nbsp;&nbsp;<i class="fa fa-envelope"></i> <a href="mailto:anton@alarm.ru">anton@alarm.ru</a></span>
        </div>
    </footer>
</template>
<script>
  export default {
    name: 'footer'
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?ba1884b2